(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2rxJM", function(module, exports) {

$parcel$export(module.exports, "setLinesWrapper", () => $1c7845f0e1de0887$export$8f060496e19d4bbb);
function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        const wrapper = document.createElement("span");
        wrapper.classList.add("line-wrapper");
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
    });
    if (typeof callback === "function") callback();
}

});


var $2rxJM = parcelRequire("2rxJM");
// Link timelines to scroll position
function $eaf0ffba354033a7$var$createIntroText(triggerElement, index, amount) {
    const isFirst = index === 0;
    const isLast = index === amount - 1;
    // Split all words on the brand core section
    const aboutIntroText = new SplitType(triggerElement.querySelectorAll(".intro-text"), {
        types: isLast ? "words" : "lines",
        tagName: "span"
    });
    (0, $2rxJM.setLinesWrapper)(isLast ? aboutIntroText.words : aboutIntroText.lines, ()=>{
        if (isLast) gsap.set(aboutIntroText.words, {
            yPercent: 100
        });
        else if (!isFirst) gsap.set(aboutIntroText.lines, {
            yPercent: 100
        });
    });
    const words = isLast ? aboutIntroText.words : aboutIntroText.lines;
    if (!isFirst) gsap.fromTo(words, {
        yPercent: 100
    }, {
        yPercent: 0,
        stagger: 0.1,
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: "top top",
            end: "20% top",
            // markers: true,
            pin: false
        }
    });
    if (!isLast) gsap.fromTo(words, {
        yPercent: 0
    }, {
        yPercent: -100,
        stagger: 0.1,
        immediateRender: false,
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: "90% bottom",
            end: "bottom bottom",
            // markers: true,
            pin: false
        }
    });
}
function $eaf0ffba354033a7$export$1c0803c11a49f237() {
    const sections = document.querySelectorAll(".intro-sequence .sticky-wrapper");
    // document
    //   .querySelector(".section.home-hero .bg-canvas-el")
    //   .classList.add("init");
    sections.forEach((section, i)=>{
        $eaf0ffba354033a7$var$createIntroText(section, i, sections.length);
    });
}



var $2rxJM = parcelRequire("2rxJM");
function $cc73ab435fc7f6d4$export$2431002dbf51daf3() {
    const team = document.querySelectorAll(".team-member-item");
    if (!team) return;
    team.forEach((member)=>{
        const trigger = member.querySelector(".team-member"), modal = member.querySelector(".team-member_modal");
        if (!trigger || !modal) return;
        const close = modal.querySelector(".team-member_modal-close"), videoThumb = modal.querySelector(".team-member_video-trigger"), videoClose = modal.querySelector(".team-member_video-close");
        const tl = $cc73ab435fc7f6d4$var$setModal(modal);
        const videoTl = $cc73ab435fc7f6d4$var$setVideoModal(modal);
        let player;
        console.log(typeof Vimeo !== "undefined", modal.dataset.video, $cc73ab435fc7f6d4$var$isVimeoEmbedUrl(modal.dataset.video));
        if (typeof Vimeo !== "undefined" && $cc73ab435fc7f6d4$var$isVimeoEmbedUrl(modal.dataset.video)) {
            player = new Vimeo.Player(modal.querySelector("iframe"));
            videoTl.eventCallback("onComplete", ()=>{
                player.play();
            });
            videoTl.eventCallback("onReverseComplete", ()=>{
                player.setCurrentTime(0);
            });
        }
        trigger.addEventListener("click", ()=>$cc73ab435fc7f6d4$var$openModal(tl));
        close.addEventListener("click", ()=>$cc73ab435fc7f6d4$var$closeModal(tl));
        videoThumb.addEventListener("click", ()=>{
            $cc73ab435fc7f6d4$var$openModal(videoTl);
        });
        videoClose.addEventListener("click", ()=>{
            if (player) player.pause();
            $cc73ab435fc7f6d4$var$closeModal(videoTl);
        });
        const modalCloseCircles1 = close.querySelectorAll("svg circle"), videoCloseCircles = videoClose.querySelectorAll("svg circle");
        close.addEventListener("mouseenter", ()=>{
            gsap.fromTo(modalCloseCircles1, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.01,
                stagger: {
                    from: "random",
                    each: 0.05
                },
                ease: "none"
            });
        });
        videoClose.addEventListener("mouseenter", ()=>{
            gsap.fromTo(videoCloseCircles, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.01,
                stagger: {
                    from: "random",
                    each: 0.05
                },
                ease: "none"
            });
        });
    });
}
function $cc73ab435fc7f6d4$var$setModal(modal) {
    const imgWrapper = modal.querySelector(".team-member_modal-img"), contentWrapper = modal.querySelector(".team-member_modal-content"), content = contentWrapper.querySelectorAll(".text-rich-text > *"), backdrop = modal.querySelector(".team-member_modal-backdrop"), videoThumb = modal.querySelector(".team-member_video-trigger");
    modalCloseCircles = modal.querySelectorAll(".team-member_modal-close svg circle");
    gsap.set(imgWrapper, {
        height: 0
    });
    gsap.set(contentWrapper, {
        height: 0
    });
    gsap.set(backdrop, {
        display: "none",
        opacity: 0
    });
    gsap.set(modalCloseCircles, {
        opacity: 0
    });
    gsap.set(modal, {
        visibility: "hidden",
        backdropFilter: "blur(0px)"
    });
    if (videoThumb && modal.dataset.video) gsap.set(videoThumb, {
        clipPath: "inset(50%)"
    });
    // Split all words on the brand core section
    content.forEach((l)=>{
        const staggerTextEls = new SplitType(l, {
            types: "lines",
            tagName: "span"
        });
        (0, $2rxJM.setLinesWrapper)(staggerTextEls.lines, ()=>{
            gsap.set(staggerTextEls.lines, {
                yPercent: 100
            });
        });
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(backdrop, {
        display: "block"
    }).to(modal, {
        visibility: "visible",
        backdropFilter: "blur(24px)",
        duration: 0.5
    }, 0).to(backdrop, {
        opacity: 0.8,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(imgWrapper, {
        height: "auto",
        duration: 1,
        ease: "expo.inOut"
    }, 0.1).to(contentWrapper, {
        height: "auto",
        duration: 1,
        ease: "expo.inOut"
    }, 0.2).to(modalCloseCircles, {
        opacity: 1,
        duration: 0.01,
        stagger: {
            from: "random",
            each: 0.05
        },
        ease: "none"
    }, 0.2).to(contentWrapper.querySelectorAll(".text-rich-text .line"), {
        yPercent: 0,
        // duration: 1,
        stagger: 0.01,
        ease: "expo.inOut"
    }, 0.5);
    if (videoThumb && modal.dataset.video) tl.to(videoThumb, {
        clipPath: "inset(0%)",
        duration: 0.5,
        ease: "expo.inOut"
    }, 0.5);
    return tl;
}
function $cc73ab435fc7f6d4$var$setVideoModal(modal) {
    const videoEl = modal.querySelector(".team-member_video-el"), backdrop = modal.querySelector(".team-member_video-el-backdrop"), videoPlayer = modal.querySelector(".team-member_video-el-inner"), videoClose = modal.querySelector(".team-member_video-close");
    gsap.set(videoEl, {
        visibility: "hidden",
        backdropFilter: "blur(0px)"
    });
    gsap.set(backdrop, {
        display: "none",
        opacity: 0
    });
    gsap.set(videoPlayer, {
        clipPath: "inset(50%)"
    });
    gsap.set(videoClose, {
        scale: 0
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(backdrop, {
        display: "block"
    }).to(videoEl, {
        visibility: "visible",
        backdropFilter: "blur(24px)",
        duration: 0.5
    }, 0).to(backdrop, {
        opacity: 0.8,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(videoPlayer, {
        clipPath: "inset(0%)",
        duration: 1,
        ease: "expo.inOut"
    }, 0.2).to(videoClose, {
        scale: 1,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0.4);
    return tl;
}
async function $cc73ab435fc7f6d4$var$openModal(tl) {
    tl.play();
}
function $cc73ab435fc7f6d4$var$closeModal(tl) {
    tl.reverse();
}
function $cc73ab435fc7f6d4$var$isVimeoEmbedUrl(url) {
    const vimeoEmbedPattern = /^https:\/\/player\.vimeo\.com\/video\/\d+([?#].*)?$/;
    return vimeoEmbedPattern.test(url);
}


document.fonts.ready.then(()=>{
    (0, $eaf0ffba354033a7$export$1c0803c11a49f237)();
    (0, $cc73ab435fc7f6d4$export$2431002dbf51daf3)();
});

})();
//# sourceMappingURL=about.js.map
